window.$ = window.jQuery = require('jquery');
require('popper.js');
require('bootstrap');
